export enum Routes {
  MENUS_ALL = "/wp-api-menus/v2/menus",
  MENUS_SINGLE = "/wp-api-menus/v2/menus",
  PAGES_ALL = "/wp/v2/pages",
  PAGES_SINGLE = "/wp/v2/pages",
  POSTS_SINGLE = "/wp/v2/posts",
  MEDIA_SINGLE = "/wp/v2/media",
}
